/**
 * EventBusEvent class
 */

class EventBusEvent {
    // @deprecated
    static EVENT_NAVIGATE = 'navigate';
    // @deprecated
    static EVENT_STATE_CHANGE = 'state-change';

    /**
     * @type {string}
     */
    ns;

    /**
     * @type {string}
     */
    type;

    /**
     * @type {Record<string, any>}
     */
    context;

    /**
     * EventBusEvent
     * @param {string} type     event type
     * @param {string} [ns='']       event namespace @default '''
     * @param {Record<string, any>} [context]
     */
    constructor(type, ns = '', context) {
        this.type = type;
        this.ns = ns;
        this.context = context;

        return Object.freeze(this);
    }

    /**
     * @type {string}
     */
    get fullType() {
        return this.ns ? `${this.type}.${this.ns}` : this.type;
    }

    /**
     * Factory method
     * @throws {Error}
     * @param {string|EventBusEvent} typeOrEvent
     * @param {IArguments} args
     * @return {EventBusEvent}
     */
    static create(typeOrEvent, ...args) {
        if (typeOrEvent instanceof EventBusEvent) {
            return typeOrEvent;
        }
        if (typeof typeOrEvent === 'string') {
            return new EventBusEvent(typeOrEvent, ...args);
        }
        throw new Error('Invalid argument type');
    }
}

export default EventBusEvent;
